import React from 'react';
import PropTypes from 'prop-types';

import FieldLabel from '../FieldLabel';
import styles from './styles.scss';
import Select from '../Select';
import withValidation from '../../shared/withValidation';

const defaultProps = {
  options: [],
};

class LabeledFetchSelect extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fetchedValue: '',
      fetchedOptions: [],
    };
  }

  componentDidMount() {
    this.props.fetchValue().then((value) => {
      this.setState({ fetchedValue: value });
    });

    this.props.fetchOptions().then((value) => {
      this.setState({ fetchedOptions: value });
    });
  }

  render() {
    const { editMode, label, value, isnLabel, error } = this.props;
    const { fetchedValue, fetchedOptions } = this.state;

    return (
      <div>
        <FieldLabel isnLabel={isnLabel}>{label}</FieldLabel>
        <Choose>
          <When condition={editMode}>
            <Select {...this.props} value={value} options={fetchedOptions} />
          </When>
          <Otherwise>
            <label className={`d-block ${styles.label}`}>{fetchedValue || '-'}</label>
            {error && <label className={styles.error}>{error}</label>}
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

LabeledFetchSelect.propTypes = {
  editMode: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  value: PropTypes.string,
  type: PropTypes.string,
  isnLabel: PropTypes.bool,
  options: PropTypes.array,
  fetchValue: PropTypes.func,
  allowBlank: PropTypes.bool,
  fetchOptions: PropTypes.func,
  error: PropTypes.string,
};

LabeledFetchSelect.defaultProps = defaultProps;
export default withValidation(LabeledFetchSelect);



// WEBPACK FOOTER //
// src/components/shared/LabeledFetchSelect/index.jsx